import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 3000 }
  }

  connect() {
    // Устанавливаем таймер для автоматического скрытия элемента
    this.timeout = setTimeout(() => {
      this.hideElement()
    }, this.delayValue)
  }

  disconnect() {
    // Очищаем таймер при отключении контроллера
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  hideElement() {
    // Плавно скрываем элемент
    this.element.style.transition = "opacity 0.5s ease"
    this.element.style.opacity = "0"

    // После завершения анимации удаляем элемент из DOM
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.parentNode.removeChild(this.element)
      }
    }, 500)
  }
}